import React, { useEffect, useRef, useState } from "react";
import JsBarcode from "jsbarcode";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
// import Select from "../../../components/select";
import SelectInput from "../../../components/select";
import CheckBox from "../../../components/check-box";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    clear_employee,
    updateEmployee,
    UPDATE_EMPLOYEE,
    getAllEmployees,
    getLogsEmployees,
    getLogsAffiliationsEmployees,
    CREATE_LOG_ABSENCE_EMPLOYEE,
    createLogAbsenceEmployee,
    get_employee_detail,
    generateCardEmployee,
    unlinkCardEmployee,
} from "../../../redux/employees";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingSpinner from "../../../components/loading-spinner";
import { get_all_companies } from "../../../redux/company";
import { getAllJobs } from "../../../redux/jobs";
import { get_all_establishments } from "../../../redux/establishment";
import { getAllReasonDismissal } from "../../../redux/reason_dismissal";
import { get_all_bank } from "../../../redux/banks";
import { getAllReasonMovement } from "../../../redux/reason_movement";
import Modal from "../../../components/modal";
import { URLAPI, CERTIFCATE_DOWNLOAD_PDF_PATH } from "../../../config"
import { Switch, Space } from "antd";
import Select from "react-select";
import {get_all_type_day} from "../../../redux/type_day";
import {formatCardCode, isLegacyCardCode} from "./card-code";

const UpdateEmployee = (props) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    let history = useHistory();

    /* A state variable that is used to store the form data. */
    const [form, setForm] = useState({
        ruc: "",
        nombres: "",
        apellidos: "",
        id_cargo: 0,
        cargo: "",
        id_empresa: 0,
        id_contribuyente_activo: 0,
        id_establecimiento: 0,
        id_establecimiento_afiliacion: 0,
        empresa: "",
        contribuyente_activo: "",
        establecimiento: "",
        establecimiento_afiliacion: "",
        id_banco: 0,
        banco: "",
        numero_cuenta: "",
        tipo_cuenta: "",
        id_tipo_jornada: 0,
        tipo_jornada: 0,
        tipo_afiliacion: 0,
        imagen: "",
        correo: "",
        telefono: "",
        fecha_ingreso: "",
        fecha_salida: "",
        motivo: "",
        activo: true,
        motivo_despido: "",
        id_motivo_despido: 0,
        id_motivo_movimiento: 0,
        correos_adicionales: [],
        nuevo_empleado: false,
        fecha_movimiento: new Date(),
        logs: [],
    });

    const [permisos, setPermisos] = useState([]);
    const [logsAffiliations, setLogsAffiliations] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalAusencia, setModalAusencia] = useState(false);
    const [modalCertificate, setModalCertificate] = useState(false);
    const [ausencia, setAusencia] = useState({
        empleado_id: id,
        fecha_inicio: '',
        fecha_fin: '',
        establecimiento_id: 0,
        motivo_id: 0,
        motivo: ''
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            console.log(array.filter(x => x.codigo === 'update_employing_company').length)
            setPermisos(array);
        }
    }, [props]);

    const { token } = useSelector((state) => state.users_module.login.data) || null;

    const [isLoading, setIsLoading] = useState(false);
    const [banks, setBanks] = useState([]);

    useEffect(() => {
        if (permisos) {
            dispatch(get_all_companies(token));
            dispatch(getAllJobs(token));
            dispatch(get_all_establishments(token));
            dispatch(getAllReasonDismissal(token));
            dispatch(get_all_bank(token));
            dispatch(getAllReasonMovement(token));
            dispatch(get_all_type_day(token));
        }

    }, [token, dispatch, permisos]);

    const _get_all_reason_dismissal = useSelector(
        (state) => state.reason_dismissal_module._get_all_reason_dismissal
    );
    const _companies = useSelector((state) => state.company_module._get_all_companies);
    const _establishment = useSelector((state) => state.establishment_module._get_all_establishments);
    const _update_employee = useSelector((state) => state.employees_module._update_employee);
    // const _get_all_employees = useSelector((state) => state.employees_module._get_all_employees);
    const _get_all_bank = useSelector((state) => state.bank_module._get_all_bank);
    const _jobs = useSelector((state) => state.jobs_module._get_all_jobs);
    const logs_affiliations_employees = useSelector((state) => state.employees_module._get_logs_affiliations_employees);
    const _get_all_type_day = useSelector((state) => state.type_day_module._get_all_type_day);

    const _get_all_reason_movement = useSelector((state) => state.reason_movement_module._get_all_reason_movement);

    const _create_log_absence_employee = useSelector((state) => state.employees_module._create_log_absence_employee);


    const [companies, setCompanies] = useState([]);
    const [reason_dismissal, setReasonDismissal] = useState([]);
    const [reason_movement, setReasonMovement] = useState([]);
    const [reason_absence, setReasonAbsence] = useState([]);
    const [establishments, setEstablishments] = useState([]);
    const [establishmentsAbsence, setEstablishmentsAbsence] = useState([]);
    const [establishmentsAffiliations, setEstablishmentsAffiliations] = useState([]);
    const [typeDays, setTypeDays] = useState([]);

    useEffect(() => {
        if (logs_affiliations_employees && logs_affiliations_employees.data && logs_affiliations_employees.data.datos) {
            setLogsAffiliations(logs_affiliations_employees.data.datos);
        }
    }, [logs_affiliations_employees]);

    useEffect(() => {
        if (_companies && _companies.data && _companies.data.datos) {
            setCompanies(_companies.data.datos);
        }
    }, [_companies]);

    useEffect(() => {
        if (_get_all_reason_movement && _get_all_reason_movement.data && _get_all_reason_movement.data.datos) {
            let fiter = _get_all_reason_movement.data.datos.filter(x => x.activo === true && x.tipo === 'MOVIMIENTO');
            let absence = _get_all_reason_movement.data.datos.filter(x => x.activo === true && x.tipo === 'AUSENCIA');
            setReasonMovement(fiter);
            setReasonAbsence(absence);
        }
    }, [_get_all_reason_movement]);

    useEffect(() => {
        if (_get_all_reason_dismissal && _get_all_reason_dismissal.data && _get_all_reason_dismissal.data.datos) {
            let fiter = _get_all_reason_dismissal.data.datos.filter(x => x.activo === true);
            setReasonDismissal(fiter);
        }
    }, [_get_all_reason_dismissal]);

    useEffect(() => {
        if (_get_all_type_day && _get_all_type_day.data && _get_all_type_day.data.datos) {
            setTypeDays(_get_all_type_day.data.datos);
        }
    }, [_get_all_type_day]);

    useEffect(() => {
        if (_establishment && _establishment.data && _establishment.data.datos) {
            // eslint-disable-next-line
            let filter = _establishment.data.datos.map(x => {
                if (x.activo === true) {
                    return {
                        value: x.id,
                        label: x.nombre
                    }
                }
            });
            setEstablishmentsAbsence(filter);
            setEstablishments(_establishment.data.datos);
            setEstablishmentsAffiliations(_establishment.data.datos);
        }
    }, [_establishment]);

    // useEffect(() => {
    //     dispatch(getAllEmployees(token));
    // }, [token, dispatch]);

    async function searchDetailEmployee(id) {
        setIsLoading(true);
        try {
            const response = await get_employee_detail(token, id);
            if (response && response.data && response.data.datos) {
                let item = response.data.datos[0];
                setForm(item);
                let v_establishment = _establishment.data.datos.filter(x => item.id_empresa === x.id_empresa);
                let v_establishmentAffiliations = _establishment.data.datos.filter(x => item.id_contribuyente_activo === x.id_empresa);
                setEstablishmentsAffiliations(v_establishmentAffiliations);
                setEstablishments(v_establishment);
                // setCategories(response.data);
            }
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        searchDetailEmployee(id);
        // if (_get_all_employees && _get_all_employees.data && _get_all_employees.data.datos && _establishment && _establishment.data && _establishment.data.datos) {
        //     // eslint-disable-next-line
        //     _get_all_employees.data.datos.map((item) => {
        //         if (item.id === parseInt(id)) {
        //             console.log(item);
        //             setForm(item);
        //             let v_establishment = _establishment.data.datos.filter(x => item.id_empresa === x.id_empresa);
        //             let v_establishmentAffiliations = _establishment.data.datos.filter(x => item.id_contribuyente_activo === x.id_empresa);
        //             setEstablishments(v_establishment);
        //             setEstablishmentsAffiliations(v_establishmentAffiliations);
        //         }
        //     });
        // }
        // eslint-disable-next-line
    }, [_establishment, id, token]);

    /* A state variable that is used to store the form data. */
    useEffect(() => {
        if (_update_employee.status === 200) {
            toast.success("El empleado ha sido actualizado correctamente")
            dispatch(clear_employee(UPDATE_EMPLOYEE));
            history.push("/empleados");
            dispatch(getAllEmployees(token));
            setIsLoading(false);
            dispatch(getLogsEmployees(token, '', 1));
            dispatch(getLogsAffiliationsEmployees(token, '', '', 1));
        } else {
            if (_update_employee.status !== 0) {
                toast.error(_update_employee.message);
                setIsLoading(false);
            }
        }
    }, [_update_employee, token, dispatch, history]);

    const barcodeRef = useRef(null);
    const [generandoCodigo, setGenerandoCodigo] = useState(false);
    const [confirmarRegenerar, setConfirmarRegenerar] = useState(false);
    const puedeEditarTarjeta = permisos.filter(x => x.codigo === 'update_field_employee').length > 0;
    const cancelarRegenerarRef = useRef(null);
    const regenerarTriggerRef = useRef(null);
    const devolverFocoRef = useRef(false);
    const generandoRef = useRef(false);

    // Modal de confirmación accesible: foco inicial en Cancelar (opción segura), Escape cierra y el foco
    // vuelve al botón que lo abrió.
    useEffect(() => {
        if (!confirmarRegenerar) return undefined;
        regenerarTriggerRef.current = document.activeElement;
        if (cancelarRegenerarRef.current) cancelarRegenerarRef.current.focus();
        const onKeyDown = (e) => {
            if (e.key === 'Escape') setConfirmarRegenerar(false);
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
            // El foco se devuelve en el efecto de abajo, cuando el botón ya no esté deshabilitado
            // (al confirmar, generandoCodigo pasa a true en el mismo lote y un botón disabled no recibe foco).
            devolverFocoRef.current = true;
        };
    }, [confirmarRegenerar]);

    useEffect(() => {
        if (!devolverFocoRef.current || confirmarRegenerar || generandoCodigo) return;
        devolverFocoRef.current = false;
        const trigger = regenerarTriggerRef.current;
        if (trigger && typeof trigger.focus === 'function' && document.body.contains(trigger)) trigger.focus();
    }, [confirmarRegenerar, generandoCodigo]);

    useEffect(() => {
        if (form.tarjeta_nfc && barcodeRef.current) {
            JsBarcode(barcodeRef.current, form.tarjeta_nfc, {
                format: "CODE128",
                displayValue: true,
                text: formatCardCode(form.tarjeta_nfc),
                height: 60,
                margin: 8,
            });
        }
    }, [form.tarjeta_nfc]);

    function handleDownloadBarcode() {
        if (!barcodeRef.current) return;
        const link = document.createElement("a");
        link.download = `tarjeta_${id}.png`; // sin el código en el nombre: queda en Descargas
        link.href = barcodeRef.current.toDataURL("image/png");
        link.click();
    }

    async function handleGenerateCard() {
        // POST /employee/card/generate/<id>/: el backend crea un código aleatorio de 12 caracteres y
        // reemplaza el anterior, que deja de servir en el kiosco en ese momento.
        // El código nuevo se muestra solo en la ficha (canvas); los toasts no lo repiten por si la pantalla se comparte.
        if (generandoRef.current) return; // ya hay una petición en curso (doble clic)
        generandoRef.current = true;
        setConfirmarRegenerar(false);
        setGenerandoCodigo(true);
        const result = await dispatch(generateCardEmployee(token, id));
        if (result.status === 200 && result.data && result.data.codigo) {
            setForm((prev) => ({...prev, tarjeta_nfc: result.data.codigo}));
            toast.success(result.message || "Código generado correctamente");
        } else if (result.status === 401) {
            toast.error(result.message || "No tienes permiso para generar códigos de tarjeta");
        } else if (result.status === 409) {
            toast.error(result.message || "Otro cambio se cruzó con este; intenta de nuevo");
        } else {
            toast.error(result.message || "No se pudo generar el código, intenta de nuevo");
        }
        generandoRef.current = false;
        setGenerandoCodigo(false);
    }

    async function handleUnlinkCard() {
        setGenerandoCodigo(true);
        const result = await dispatch(unlinkCardEmployee(token, id));
        if (result.status === 200) {
            setForm((prev) => ({...prev, tarjeta_nfc: null}));
            toast.success("Tarjeta desvinculada correctamente");
        } else {
            toast.error(result.message || "Ocurrió un error al desvincular la tarjeta");
        }
        setGenerandoCodigo(false);
    }

    const [jobs, setJobs] = useState([]);

    useEffect(() => {
        if (_jobs && _jobs.data && _jobs.data.datos) {
            let cargos = _jobs.data.datos.filter(x => x.activo === true)
            setJobs(cargos);
        }
    }, [_jobs]);

    useEffect(() => {
        if (_get_all_bank && _get_all_bank.data && _get_all_bank.data.datos) {
            let filter = _get_all_bank.data.datos.filter(x => x.activo === true);
            setBanks(filter);
        }
    }, [_get_all_bank]);

    const handleChange = (e) => {
        if (e.target.name === 'activo' || e.target.name === 'nuevo_empleado') {
            setForm({
                ...form,
                [e.target.name]: e.target.checked,
            });
        } else if (e.target.name === "id_cargo" || e.target.name === "id_empresa" || e.target.name === "id_contribuyente_activo" || e.target.name === "id_establecimiento" || e.target.name === "id_establecimiento_afiliacion" || e.target.name === "id_banco" || e.target.name === "id_motivo_despido" || e.target.name === "id_motivo_movimiento") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
            if (e.target.name === "id_empresa") {
                document.getElementById("id_establecimiento").selectedIndex = 0;
                let v_establishment = _establishment.data.datos.filter(x => parseInt(e.target.value) === parseInt(x.id_empresa));
                setEstablishments(v_establishment);
            }
            if (e.target.name === "id_contribuyente_activo") {
                document.getElementById("id_establecimiento_afiliacion").selectedIndex = 0;
                let v_establishmentAffiliations = _establishment.data.datos.filter(x => parseInt(e.target.value) === parseInt(x.id_empresa));
                setEstablishmentsAffiliations(v_establishmentAffiliations);
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleChangeEmail = (e) => {
        let correos = form.correos_adicionales;
        // eslint-disable-next-line
        correos.map(c => {
            if (c.label === e.target.name) {
                c.value = e.target.value
            }
        })

        setForm({
            ...form,
            correos_adicionales: correos
        })
    }

    const [count, setCount] = useState(1);

    function add_email() {
        const c = "Correo" + count;
        const correos = form.correos_adicionales;
        correos.push({ 'label': c, 'value': '' });
        setForm({
            ...form,
            correos_adicionales: correos,
        });
        setCount(count + 1);
    }

    const [imagePreview, setImagePreview] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        let url = URL.createObjectURL(file);
        setImagePreview(url);
        setForm({
            ...form,
            imagen: e.target.files[0],
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        //validate fields
        if (form.ruc === "") {
            toast.error("Debe ingresar el ruc");
            setIsLoading(false);
            return;
        }
        if (form.nombres === "") {
            toast.error("Debe ingresar el nombre");
            setIsLoading(false);
            return;
        }
        if (form.apellidos === "") {
            toast.error("Debe ingresar el apellido");
            setIsLoading(false);
            return;
        }
        if (form.correo === "") {
            toast.error("Debe ingresar el correo electrónico");
            setIsLoading(false);
            return;
        }
        if (form.imagen === "") {
            toast.error("La imagen es requerida");
            setIsLoading(false);
            return;
        }
        if (form.id_contribuyente_activo === 0) {
            toast.error("Debe seleccionar el contribuyente activo");
            setIsLoading(false);
            return;
        }
        if (form.id_establecimiento_afiliacion === 0) {
            toast.error("Debe seleccionar el establecimiento de afiliación");
            setIsLoading(false);
            return;
        }
        if (form.id_cargo === 0) {
            toast.error("Debe seleccionar el cargo");
            setIsLoading(false);
            return;
        }
        if (form.id_empresa === 0) {
            toast.error("Debe seleccionar la empresa");
            setIsLoading(false);
            return;
        }
        if (form.id_establecimiento === 0) {
            toast.error("Debe seleccionar el establecimiento");
            setIsLoading(false);
            return;
        }
        if (form.id_tipo_jornada === 0) {
            toast.error("Debe seleccionar tipo de jornada");
            setIsLoading(false);
            return;
        }
        if (form.tipo_afiliacion === 0) {
            toast.error("Debe seleccionar tipo de jornada");
            setIsLoading(false);
            return;
        }
        if (Date.parse(form.fecha_movimiento) > new Date()) {
            toast.error("La fecha de movimiento no puede ser mayor a la fecha actual");
            setIsLoading(false);
            return;
        }
        if (form.id_motivo_movimiento === 0) {
            toast.error("Debe seleccionar el motivo de movimiento");
            setIsLoading(false);
            return;
        }
        if (form.activo === false) {
            if (form.fecha_salida === null) {
                toast.error("Debe ingresar la fecha de salida");
                setIsLoading(false);
                return;
            }
            if (form.id_motivo_despido === 0) {
                toast.error("Debe seleccionar el motivo de salida");
                setIsLoading(false);
                return;
            }
        }
        dispatch(updateEmployee(token, id, form));
    };

    const handleChangeAusencia = (e) => {
        if (e.target.name === "establecimiento_id"|| e.target.name === "motivo_id") {
            setAusencia({
                ...ausencia,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setAusencia({
                ...ausencia,
                [e.target.name]: e.target.value,
            });
        }
    };

    useEffect(() => {
        if (_create_log_absence_employee.status === 201) {
            toast.success("Ausencia creada correctamente");
            dispatch(clear_employee(CREATE_LOG_ABSENCE_EMPLOYEE));
            searchDetailEmployee(id);
            setModalAusencia(false);
            setIsLoading(false);

        } else {
            if (_create_log_absence_employee.status !== 0) {
                toast.error(_create_log_absence_employee.message);
                setIsLoading(false);
            }
        }
        // eslint-disable-next-line
    }, [_create_log_absence_employee, dispatch, history, token, id]);

    const handleSubmitAusencia = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (ausencia.fecha_inicio === '') {
            toast.error("Debe seleccionar la fecha de iniicio");
            setIsLoading(false);
            return;
        }
        if (ausencia.fecha_fin === '') {
            toast.error("Debe seleccionar la fecha final");
            setIsLoading(false);
            return;
        }
        if (Date.parse(ausencia.fecha_fin) < Date.parse(ausencia.fecha_inicio)) {
            toast.error("La fecha final debe ser mayor o igual que la fecha de inicio");
            setIsLoading(false);
            return;
        }
        // else {
        //     let date = new Date();
        //     var month = date.getMonth() + 1;
        //     if (month < 10) {
        //         month = '0' + month;
        //     }
        //     var year = date.getFullYear();
        //     var fecha = year + '-' + month + '-01';
        //     if (Date.parse(ausencia.fecha_inicio) < Date.parse(fecha)) {
        //         toast.error("La fecha de inicio no está en el rango del mes actual");
        //         setIsLoading(false);
        //         return;
        //     }
        // }

        if (ausencia.establecimiento_id === 0) {
            toast.error("Debe seleccionar un establecimiento");
            setIsLoading(false);
            return;
        }
        if (ausencia.motivo_id === 0) {
            toast.error("Debe ingresar el motivo de ausencia");
            setIsLoading(false);
            return;
        }
        dispatch(createLogAbsenceEmployee(token, ausencia))
    }

    const [remuneracion, setRemuneracion] = useState(false);

    const handleCheckedChange = (checked) => {
        setRemuneracion(checked);
    };

    const [establishment_select, setEstablishmentSelect] = useState([]);

    const handleChangeEstablishment = (e) => {
        setEstablishmentSelect(e);
        // console.log(e);
        setAusencia({...ausencia, establecimiento_id: e.value});
    }

    return (
        <div className="app-content content">
            <ToastContainer />
            {isLoading && <LoadingSpinner />}
            <div className="content-overlay" />
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Empleados"
                            items={[
                                { label: "Empleados", link: "/empleados" },
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar Empleado</h4>
                                </div>
                                <div className="card-body">
                                    <div className=" row">
                                        {permisos &&
                                            <div className="col-12 text-right">
                                                {permisos.filter(x => (x.codigo === 'update_employing_company').length > 0) &&
                                                    <Button
                                                        type="button"
                                                        text="Certificado laboral"
                                                        theme="certificate"
                                                        onChange={() => { setModalCertificate(true) }}
                                                        disabled={isLoading}
                                                        style={{ marginRight: 10 }}
                                                    />
                                                }
                                                {permisos.filter(x => (x.codigo === 'view_forms').length > 0) &&
                                                    <Button
                                                        type="button"
                                                        text="Datos del formulario"
                                                        theme="warning"
                                                        onChange={() => { history.push(`/empleado/datos/${id}`); }}
                                                        disabled={isLoading}
                                                        style={{ marginRight: 10 }}
                                                    />
                                                }
                                                {permisos.filter(x => x.codigo === 'update_employing_company').length > 0 &&
                                                    <Button
                                                        type="button"
                                                        text="Historial de afiliaciones"
                                                        theme="secondary"
                                                        onChange={() => {
                                                            setModal(true);
                                                            dispatch(getLogsAffiliationsEmployees(token, '', id, 1));
                                                        }}
                                                        disabled={isLoading}
                                                    />
                                                }
                                            </div>
                                        }
                                        <div className="col-12">
                                            <h5>Información Personal</h5>
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                label="Cédula"
                                                name="ruc"
                                                onChange={handleChange}
                                                value={form.ruc}
                                                readonly="readonly"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                label="Nombre"
                                                name="nombres"
                                                onChange={handleChange}
                                                value={form.nombres}
                                                disabled={(permisos.filter(x => x.codigo === 'update_field_employee').length > 0) ? false : true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                label="Apellidos"
                                                name="apellidos"
                                                onChange={handleChange}
                                                value={form.apellidos}
                                                disabled={(permisos.filter(x => x.codigo === 'update_field_employee').length > 0) ? false : true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                label="Correo"
                                                name="correo"
                                                onChange={handleChange}
                                                value={form.correo}
                                                disabled={(permisos.filter(x => x.codigo === 'update_field_employee').length > 0) ? false : true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                label="Telefono"
                                                name="telefono"
                                                onChange={handleChange}
                                                value={form.telefono}
                                                disabled={(permisos.filter(x => x.codigo === 'update_field_employee').length > 0) ? false : true}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <Input
                                                label="Imagen"
                                                name="imagen"
                                                type="file"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                                disabled={(permisos.filter(x => x.codigo === 'update_field_employee').length > 0) ? false : true}
                                            />
                                        </div>
                                        <div className="col-md-8 text-center">
                                            <img
                                                src={
                                                    imagePreview == null
                                                        ? `${URLAPI}${form.foto}`
                                                        : imagePreview
                                                }
                                                alt="imagen"
                                                width={60}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-6">
                                            <label className="d-block">Tarjeta / código de barras</label>
                                            {form.tarjeta_nfc ? (
                                                <>
                                                    <canvas ref={barcodeRef} />
                                                    {isLegacyCardCode(form.tarjeta_nfc) && (
                                                        <small className="d-block text-warning">
                                                            Código anterior, fácil de adivinar: se recomienda regenerarlo e imprimir la tarjeta nueva.
                                                        </small>
                                                    )}
                                                    <div className="mt-1">
                                                        <Button
                                                            text="Descargar PNG"
                                                            onChange={handleDownloadBarcode}
                                                            theme="secondary"
                                                            classes="btn-sm"
                                                        />
                                                        {puedeEditarTarjeta && (
                                                            <>
                                                                <Button
                                                                    text={generandoCodigo ? "Generando..." : "Regenerar código"}
                                                                    onChange={() => setConfirmarRegenerar(true)}
                                                                    theme="warning"
                                                                    classes="btn-sm ml-1"
                                                                    disabled={generandoCodigo}
                                                                />
                                                                <Button
                                                                    text="Desvincular"
                                                                    onChange={handleUnlinkCard}
                                                                    theme="danger"
                                                                    classes="btn-sm ml-1"
                                                                    disabled={generandoCodigo}
                                                                />
                                                            </>
                                                        )}
                                                    </div>
                                                </>
                                            ) : (
                                                puedeEditarTarjeta ? (
                                                    <Button
                                                        text={generandoCodigo ? "Generando..." : "Generar código"}
                                                        onChange={handleGenerateCard}
                                                        theme="secondary"
                                                        classes="btn-sm"
                                                        disabled={generandoCodigo}
                                                    />
                                                ) : (
                                                    <span className="text-muted">Código no disponible</span>
                                                )
                                            )}
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-6">
                                            <label className="d-block">Calificaciones</label>
                                            {form.calificacion_promedio && form.calificacion_promedio.total > 0 ? (
                                                <span>
                                                    😞 {form.calificacion_promedio.malo}{' '}
                                                    😐 {form.calificacion_promedio.regular}{' '}
                                                    😊 {form.calificacion_promedio.bueno}{' '}
                                                    🥳 {form.calificacion_promedio.excelente}{' '}
                                                    = {form.calificacion_promedio.total}
                                                </span>
                                            ) : (
                                                <span className="text-muted">Sin calificaciones aún</span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-12">
                                            <h5>Afiliación</h5>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Contribuyente activo</label>
                                                <SelectInput
                                                    label="Contribuyente activo"
                                                    name="id_contribuyente_activo"
                                                    value={form.id_contribuyente_activo}
                                                    select={form.contribuyente_activo}
                                                    options={companies.map((company) => ({
                                                        name: company.nombre,
                                                        id: company.id,
                                                    }))}
                                                    onChange={handleChange}
                                                    disabled={(permisos.filter(x => x.codigo === 'update_employing_company').length > 0) ? false : true}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Establecimiento de afiliación</label>
                                                <SelectInput
                                                    id="id_establecimiento_afiliacion"
                                                    label="Establecimiento de afiliación"
                                                    name="id_establecimiento_afiliacion"
                                                    value={form.id_establecimiento_afiliacion}
                                                    select={form.establecimiento_afiliacion}
                                                    options={establishmentsAffiliations.map((item) => ({
                                                        name: item.nombre,
                                                        id: item.id,
                                                    }))}
                                                    onChange={handleChange}
                                                    disabled={(permisos.filter(x => x.codigo === 'update_employing_company').length > 0) ? false : true}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                type="date"
                                                label="Fecha Ingreso"
                                                name="fecha_ingreso"
                                                onChange={handleChange}
                                                value={form.fecha_ingreso}
                                                disabled={(permisos.filter(x => x.codigo === 'update_field_employee').length > 0) ? false : true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label>Tipo de afiliación</label>
                                            <select
                                                className='form-control'
                                                name='tipo_afiliacion'
                                                required={true}
                                                onChange={handleChange}
                                                disabled={(permisos.filter(x => x.codigo === 'update_field_employee').length > 0) ? false : true}
                                            >
                                                <option value={0} hidden>Seleccione un tipo de jornada</option>
                                                <option value="ingreso" selected={form.tipo_afiliacion === 'ingreso'}>INGRESO</option>
                                                <option value="traspaso" selected={form.tipo_afiliacion === 'traspaso'}>TRASPASO</option>
                                                <option value="reingreso" selected={form.tipo_afiliacion === 'reingreso'}>REINGRESO</option>
                                            </select>
                                        </div>
                                        {/*<div className="col-4">*/}
                                        {/*    <CheckBox label="Fondo de reserva" name="fondo_reserva" id="fondo_reserva"*/}
                                        {/*              onChange={handleChange} state={form.fondo_reserva} disabled={(permisos.filter(x => x.codigo === 'update_field_employee').length > 0) ? false : true}/>*/}
                                        {/*</div>*/}
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-12">
                                            <h5>Traslados / Traspasos</h5>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Cargo</label>
                                                <SelectInput
                                                    label="Cargo"
                                                    name="id_cargo"
                                                    value={form.id_cargo}
                                                    select={form.cargo}
                                                    options={jobs.map((job) => ({
                                                        name: job.nombre,
                                                        id: job.id,
                                                    }))}
                                                    onChange={handleChange}
                                                    disabled={(permisos.filter(x => x.codigo === 'update_field_transfers').length > 0) ? false : true}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Empresa</label>
                                                <SelectInput
                                                    label="Empresa"
                                                    name="id_empresa"
                                                    value={form.id_empresa}
                                                    select={form.empresa}
                                                    options={companies.map((company) => ({
                                                        name: company.nombre,
                                                        id: company.id,
                                                    }))}
                                                    onChange={handleChange}
                                                    disabled={(permisos.filter(x => x.codigo === 'update_field_transfers').length > 0) ? false : true}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Establecimiento</label>
                                                <SelectInput
                                                    id="id_establecimiento"
                                                    label="Establecimiento"
                                                    name="id_establecimiento"
                                                    value={form.id_establecimiento}
                                                    select={form.establecimiento}
                                                    options={establishments.map((item) => ({
                                                        name: item.nombre,
                                                        id: item.id,
                                                    }))}
                                                    onChange={handleChange}
                                                    disabled={(permisos.filter(x => x.codigo === 'update_field_transfers').length > 0) ? false : true}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label>Tipo de jornada</label>
                                            <SelectInput
                                                label="Tipo de jornada"
                                                name="id_tipo_jornada"
                                                value={form.id_tipo_jornada}
                                                select={form.tipo_jornada}
                                                options={typeDays.map((td) => ({
                                                    name: td.descripcion,
                                                    id: td.id,
                                                }))}
                                                onChange={handleChange}
                                                disabled={(permisos.filter(x => x.codigo === 'update_field_transfers').length > 0) ? false : true}
                                            />
                                            {/*<select*/}
                                            {/*    className='form-control'*/}
                                            {/*    name='tipo_jornada'*/}
                                            {/*    required={true}*/}
                                            {/*    onChange={handleChange}*/}
                                            {/*    disabled={(permisos.filter(x => x.codigo === 'update_field_transfers').length > 0) ? false : true}*/}
                                            {/*>*/}
                                            {/*    <option value={0} hidden>Seleccione un tipo de jornada</option>*/}
                                            {/*    <option value="complete"*/}
                                            {/*        selected={form.tipo_jornada === 'complete'}>Completa*/}
                                            {/*    </option>*/}
                                            {/*    <option value="partial"*/}
                                            {/*        selected={form.tipo_jornada === 'partial'}>Parcial*/}
                                            {/*    </option>*/}
                                            {/*    <option value="maternidad"*/}
                                            {/*        selected={form.tipo_jornada === 'maternidad'}>Maternidad*/}
                                            {/*    </option>*/}
                                            {/*</select>*/}
                                        </div>
                                        <div className="col-md-4">
                                            <Input
                                                type="date"
                                                label="Fecha de movimiento"
                                                name="fecha_movimiento"
                                                onChange={handleChange}
                                                value={form.fecha_movimiento}
                                                disabled={(permisos.filter(x => x.codigo === 'update_field_transfers').length > 0) ? false : true}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label>Motivo de movimiento</label>
                                            <SelectInput
                                                label="Motivo de movimiento"
                                                name="id_motivo_movimiento"
                                                options={reason_movement.map((item) => ({
                                                    name: item.nombre,
                                                    id: item.id,
                                                }))}
                                                onChange={handleChange}
                                                disabled={(permisos.filter(x => x.codigo === 'update_field_transfers').length > 0) ? false : true}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        {permisos.filter(x => x.codigo === 'nomina').length > 0 &&
                                            <>
                                                <div className="col-12">
                                                    <h5>Información bancaria</h5>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Banco</label>
                                                        <SelectInput
                                                            label="Banco"
                                                            name="id_banco"
                                                            options={banks.map((item) => ({
                                                                name: item.nombre,
                                                                id: item.id,
                                                            }))}
                                                            onChange={handleChange}
                                                            select={form.banco}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <label>Tipo de cuenta</label>
                                                    <select
                                                        className='form-control'
                                                        name='tipo_cuenta'
                                                        required={true}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={0} hidden>Seleccione un tipo de cuenta</option>
                                                        <option value="saving"
                                                            selected={form.tipo_cuenta === 'saving'}>Ahorro
                                                        </option>
                                                        <option value="current"
                                                            selected={form.tipo_cuenta === 'current'}>Corriente
                                                        </option>
                                                    </select>
                                                </div>
                                                <div className="col-md-4">
                                                    <Input
                                                        label="Número de cuenta"
                                                        name="numero_cuenta"
                                                        onChange={handleChange}
                                                        value={form.numero_cuenta}
                                                    />
                                                </div>
                                            </>
                                        }

                                        <div className="col-4">
                                            <CheckBox label="Activo" name="activo" id="activo" onChange={handleChange}
                                                state={form.activo} disabled={(permisos.filter(x => x.codigo === 'update_field_employee').length > 0) ? false : true}/>
                                        </div>
                                        {(form.activo === true && permisos.filter(x => x.codigo === 'update_employing_company').length > 0) &&
                                            <div className="col-md-4">
                                                <CheckBox label="Enviar notificación de empleado nuevo"
                                                    name="nuevo_empleado" id="nuevo_empleado" onChange={handleChange}
                                                    state={form.nuevo_empleado} disabled={(permisos.filter(x => x.codigo === 'update_field_employee').length > 0) ? false : true}/>
                                            </div>
                                        }
                                        {(form.activo === false) &&
                                            <div className="col-md-4">
                                                <Input
                                                    type="date"
                                                    label="Fecha salida"
                                                    name="fecha_salida"
                                                    onChange={handleChange}
                                                    value={form.fecha_salida}
                                                    disabled={(permisos.filter(x => x.codigo === 'update_field_employee').length > 0) ? false : true}
                                                />
                                            </div>
                                        }
                                        {(form.activo === false) &&
                                            <div className="col-md-4">
                                                <label>Motivo</label>
                                                <SelectInput
                                                    label="Motivo"
                                                    name="id_motivo_despido"
                                                    options={reason_dismissal.map((item) => ({
                                                        name: item.nombre,
                                                        id: item.id,
                                                    }))}
                                                    onChange={handleChange}
                                                    select={form.motivo_despido}
                                                    disabled={(permisos.filter(x => x.codigo === 'update_field_employee').length > 0) ? false : true}
                                                />
                                                {/*<select*/}
                                                {/*    className='form-control'*/}
                                                {/*    name='motivo'*/}
                                                {/*    required={true}*/}
                                                {/*    onChange={handleChange}*/}
                                                {/*>*/}
                                                {/*    <option value={0} hidden>Seleccione un motivo</option>*/}
                                                {/*    <option value="dismissal" selected={form.motivo === 'dismissal'}>Despido</option>*/}
                                                {/*    <option value="resignation" selected={form.motivo === 'resignation'}>Renuncia</option>*/}
                                                {/*    <option value="probation" selected={form.motivo === 'probation'}>Periodo de prueba</option>*/}
                                                {/*</select>*/}
                                            </div>
                                        }
                                        {(form.activo === false || form.nuevo_empleado === true) &&
                                            <>
                                                <div className="col-12 mt-2">
                                                    <div className="d-flex">
                                                        <h5 className="mt-1">Correos adicionales</h5>
                                                        <Button type="button" onClick={() => {
                                                            add_email()
                                                        }} text="Agregar" theme="btn btn-success ml-2" classes="m-1" />
                                                    </div>
                                                </div>
                                                {form.correos_adicionales.length > 0 &&
                                                    form.correos_adicionales.map(ca =>
                                                        <div className="col-md-4">
                                                            <Input
                                                                label={ca.label}
                                                                name={ca.label}
                                                                onChange={handleChangeEmail}
                                                                value={ca.value}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            </>
                                        }
                                    </div>
                                    {permisos.filter(x => x.codigo === 'registrar_ausencia').length > 0 &&
                                        <div className="row mt-2">
                                            <div className="col-12 text-right">
                                                <Button
                                                    type="button"
                                                    text="Registrar"
                                                    theme="warning"
                                                    onChange={() => {
                                                        setAusencia({ ...ausencia, fecha_inicio: '', fecha_fin: '', motivo: '', establecimiento_id: 0 });
                                                        // document.getElementById("establecimiento_id").selectedIndex = 0;
                                                        document.getElementById("motivo_id").selectedIndex = 0;
                                                        setModalAusencia(true);
                                                        setEstablishmentSelect([]);
                                                    }}
                                                    disabled={isLoading}
                                                    style={{ marginRight: 10 }}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <h5>Registro de ausencias</h5>
                                            </div>
                                            <div className="col-12 mt-2 table-responsive">
                                                <table className="table table-bordered" width="100%">
                                                    <tr>
                                                        <th className="text-center" width="20%">Fecha de inicio</th>
                                                        <th className="text-center" width="20%">Fecha final</th>
                                                        <th className="text-center" width="20%">Establecimiento</th>
                                                        <th className="text-center" width="40%">Motivo</th>
                                                    </tr>
                                                    {form.logs &&
                                                        form.logs.map(l => (
                                                            <tr>
                                                                <td>{l.fecha_inicio}</td>
                                                                <td>{l.fecha_fin}</td>
                                                                <td>{l.establecimiento}</td>
                                                                <td>{l.motivo}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </table>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    <Link to="/empleados" className="btn btn-danger m-1">
                                        Cancelar
                                    </Link>
                                    {permisos.filter(x => (x.codigo === 'update_employing_company' || x.codigo === 'change_employees')).length > 0 &&
                                        <Button
                                            text="Guardar"
                                            theme="success"
                                            type="submit"
                                            classes="m-1"
                                            onClick={handleSubmit}
                                            disabled={isLoading}
                                        />
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal1" show={modal}>
                <div className="card-body">
                    <h5>Detalles de afiliaciones</h5>
                    <h5>{form.nombres} {form.apellidos}</h5>
                    {logsAffiliations.length > 0 &&
                        logsAffiliations.map(x => (
                            <div className="border_card">
                                <strong>Fecha: </strong><span>{x.fecha}</span><br /><br />
                                <strong>Anterior</strong><br />
                                <strong>Contribuyente activo: </strong><span>{x.contribuyente_activo}</span><br />
                                <strong>Establecimiento de afiliación: </strong><span>{x.establecimiento_afiliacion}</span><br /><br />
                                <strong>Actual</strong><br />
                                <strong>Contribuyente activo: </strong><span>{x.nuevo_contribuyente_activo}</span><br />
                                <strong>Establecimiento de afiliación: </strong><span>{x.nuevo_establecimiento_afiliacion}</span><br />

                            </div>
                        )
                        )}

                    <div className="text-center mt-1">
                        <button type="button" className="btn btn-dark" onClick={() => { setModal(false) }}>Aceptar</button>
                    </div>
                </div>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalAusencia}>
                <form onSubmit={handleSubmitAusencia}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Registrar ausencia</h5>
                        <div className="form-group">
                            <Input
                                type="date"
                                label="Fecha de inicio"
                                name="fecha_inicio"
                                onChange={handleChangeAusencia}
                                value={ausencia.fecha_inicio}
                            />
                        </div>
                        <div className="form-group">
                            <Input
                                type="date"
                                label="Fecha final"
                                name="fecha_fin"
                                onChange={handleChangeAusencia}
                                value={ausencia.fecha_fin}
                            />
                        </div>
                        <div className="form-group">
                            <label>Establecimiento</label>
                            {/*<SelectInput*/}
                            {/*    id="establecimiento_id"*/}
                            {/*    label="Establecimiento"*/}
                            {/*    name="establecimiento_id"*/}
                            {/*    value={ausencia.establecimiento_id}*/}
                            {/*    onChange={handleChangeAusencia}*/}
                            {/*    options={establishmentsAbsence ? establishmentsAbsence.map((ad) => ({*/}
                            {/*        name: ad.nombre,*/}
                            {/*        id: ad.id,*/}
                            {/*    })) : []}*/}
                            {/*/>*/}
                            <Select
                                options={establishmentsAbsence}
                                isMulti={false}
                                onChange={handleChangeEstablishment}
                                value={establishment_select}
                            />
                        </div>
                        <div className="form-group">
                            <label>Motivo</label>
                            <SelectInput
                                id="motivo_id"
                                label="Motivo"
                                name="motivo_id"
                                options={reason_absence.map((item) => ({
                                    name: item.nombre,
                                    id: item.id,
                                }))}
                                onChange={handleChangeAusencia}
                            />
                            {/*<TextArea*/}
                            {/*    label="Motivo"*/}
                            {/*    name="motivo"*/}
                            {/*    onChange={handleChangeAusencia}*/}
                            {/*    value={ausencia.motivo}*/}
                            {/*    rows={5}*/}
                            {/*/>*/}
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalAusencia(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalCertificate}>
                <div className="card-body">
                    <h5>Certificado laboral</h5>
                    <div className="form-group mt-1">
                        <Space size={14} direction='horizontal'>
                            <strong>Incluir información sobre la remuneración</strong>
                            <Switch
                                checked={remuneracion}
                                checkedChildren="SI"
                                unCheckedChildren="NO"
                                onChange={handleCheckedChange}
                            />
                        </Space>
                    </div>
                    <div className="text-center mt-1">
                        {/* eslint-disable-next-line */}
                        <a href={`${URLAPI}${CERTIFCATE_DOWNLOAD_PDF_PATH}${id}/${remuneracion}/`} target="_blank" onClick={() => setModalCertificate(false)} className="btn btn-success">Descargar certificado</a>
                        <button type="button" className="btn btn-dark ml-1" onClick={() => { setModalCertificate(false) }}>Cancelar</button>
                    </div>
                </div>
            </Modal>
            <Modal className="modal-main div-modal1" show={confirmarRegenerar}>
                <div className="card-body" role="alertdialog" aria-modal="true" aria-labelledby="titulo-regenerar" aria-describedby="texto-regenerar">
                    <h5 id="titulo-regenerar">Regenerar código de tarjeta</h5>
                    <p id="texto-regenerar">
                        El código actual de {form.nombres} {form.apellidos} dejará de funcionar en el kiosco en este
                        momento. Habrá que imprimir y entregar la tarjeta nueva.
                    </p>
                    <div className="text-center mt-1">
                        <button type="button" ref={cancelarRegenerarRef} className="btn btn-dark" onClick={() => setConfirmarRegenerar(false)}>
                            Cancelar
                        </button>
                        <button type="button" className="btn btn-warning ml-1" onClick={handleGenerateCard} disabled={generandoCodigo}>
                            Regenerar código
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default UpdateEmployee;
